import * as React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { Image, UploadImage } from 'src/api';
import { TR } from 'src/TextRes';
import FAIcon from '../fAIcon/FAIcon';
import ImageChooserSingle from '../imageChooser/ImageChooserSingle';
import ImagePlaceholder from '../imageChooser/ImagePlaceholder';
import './CPProfileImage.css';

export interface CPProfileImageProps {
    cancelHandler: () => void;
    editHandler: () => void;
    saveHandler: (image?: UploadImage) => void;
    editItemKey: string | undefined;
    image?: Image;
}

export interface CPProfileImageState {
    inEditMode: boolean;
    uploadImage?: UploadImage;
}

export default class CPProfileImage extends React.PureComponent<CPProfileImageProps, CPProfileImageState> {
    constructor(props: CPProfileImageProps) {
        super(props);
        this.state = {
            inEditMode: false,
        };
    }

    public render() {
        const props = this.props;

        return (
            <div className="mt-2 mb-4 CPItemEditComponent">
                <Row>
                    <Col>
                        <h4>{TR.cPProfileImage_image}</h4>
                    </Col>
                </Row>
                {!this.state.inEditMode && (
                    <Row className="myProfileContainer">
                        <ImagePlaceholder image={props.image} />
                        {!props.editItemKey && (
                            <a className="iconButton editButton" onClick={this.onClickEditMode}>
                                <FAIcon mouseHover="bearbeiten" icon="edit" />
                            </a>
                        )}
                    </Row>
                )}
                {this.state.inEditMode && (
                    <Row className="myProfileContainer">
                        <ImageChooserSingle
                            onDelete={this.changeImage}
                            onFileChosen={this.changeImage}
                            imageData={
                                this.state.uploadImage && !this.state.uploadImage.Delete
                                    ? this.state.uploadImage.ImageData
                                    : undefined
                            }
                            imageDelete={this.state.uploadImage ? this.state.uploadImage.Delete : false}
                            image={props.image}
                        />
                    </Row>
                )}
                {this.state.inEditMode && (
                    <Row>
                        <Col md={12} className="text-right">
                            <Button className="mt-2 mb-1 mr-1" size="sm" onClick={this.onClickCancel}>
                                {TR.cPProfileImage_cancel}
                            </Button>

                            <Button className="mt-2 mb-1" size="sm" onClick={this.onSave}>
                                {TR.cPProfileImage_save}
                            </Button>
                        </Col>
                    </Row>
                )}
            </div>
        );
    }

    private changeImage = (image: UploadImage) => {
        this.setState({ uploadImage: image });
    };

    private onClickEditMode = () => {
        this.setState({ inEditMode: true }, this.props.editHandler);
    };

    private onClickCancel = () => {
        this.setState({ inEditMode: false, uploadImage: undefined }, this.props.cancelHandler);
    };

    private onSave = () => {
        const uploadImage = this.state.uploadImage;
        this.setState({ inEditMode: false, uploadImage: undefined }, () => {
            this.props.saveHandler(uploadImage);
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPProfileImage.tsx